import "./service.css";
import React from 'react';
import Navbar from "../components/navbar";
import HomeHero from "../components/hero";
import Footer from "../components/footer";
import TourCard from "../components/tourcard";
import Serv from "../assets/service.jpg";
import Tour1Image from "../assets/5.webp";  
import Tour2Image from "../assets/8.webp";  
import Tour3Image from "../assets/6.jpg"; 

function Service() {
  return (
    <>
      <Navbar />
      <HomeHero
        cName="hero-mid"
        heroImg={Serv} 
        title="Our Tour Packages"
        btnClass="hide"
      />
      <div className="tour-packages">
        <h2 className="section-title">Explore Our Packages</h2>
        <div className="tour-packages-grid">
          <TourCard
            image={Tour1Image}
            title="Adventure in Hunza"
            description="Experience the breathtaking beauty of Hunza with our guided tours through its stunning landscapes and rich culture."
            link="/tour/1" 
          />
          <TourCard
            image={Tour2Image}
            title="Relaxing Naran & Kaghan"
            description="Enjoy a peaceful retreat in Naran and Kaghan with our all-inclusive packages featuring serene lakes and lush valleys."
            link="/tour/2"
          />
          <TourCard
            image={Tour3Image}
            title="Explore Gilgit"
            description="Discover the majestic mountains and historical sites of Gilgit with our expert-guided tours and comfortable accommodations."
            link="/tour/3"
          />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Service;
